import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Button, Steps, Pagination, Carousel, Icon, message,Row,Col} from 'ant-design-vue';
import './common/font/font.css'
Vue.use(Button).use(Steps).use(Pagination).use(Carousel).use(Icon).use(message).use(Row).use(Col)
Vue.prototype.$message = message;
Vue.config.productionTip = false;
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
